import { Link } from "react-router-dom";
import { MessageSquare, ShieldCheck, Clock, ArrowRight } from "lucide-react";

// Ad-landing conversion band — a clear, self-contained call to action + trust
// signals so ANY page works as a Google Ads landing page.
export default function ConversionCTA({ heading, sub, ctaHref = "/chat" }) {
  return (
    <section className="mt-12 border-2 border-ink p-6 sm:p-8" data-testid="conversion-cta">
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-accent">Need help now?</p>
      <h2 className="mt-3 max-w-2xl font-serif text-2xl font-medium leading-tight text-ink sm:text-3xl">
        {heading || "Get your support issue sorted — talk to a specialist."}
      </h2>
      <p className="mt-3 max-w-2xl text-sm leading-relaxed text-muted">
        {sub ||
          "Describe your problem once and an independent specialist helps you reach the right official support. Your first message is free — you only pay when you're ready."}
      </p>
      <div className="mt-6 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
        <Link
          to={ctaHref}
          data-testid="conversion-cta-button"
          className="inline-flex items-center gap-2 bg-accent px-7 py-4 font-mono text-sm uppercase tracking-widest text-paper transition-opacity hover:opacity-90"
        >
          Chat with a specialist <ArrowRight className="h-4 w-4" />
        </Link>
        <span className="font-mono text-[11px] uppercase tracking-widest text-muted">
          First message free · pay only when ready
        </span>
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-[11px] uppercase tracking-widest text-muted">
        <span className="flex items-center gap-1.5"><ShieldCheck className="h-4 w-4 text-accent" /> Independent · never asks for passwords</span>
        <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-accent" /> Urgent: 15 min or it&apos;s free</span>
        <span className="flex items-center gap-1.5"><MessageSquare className="h-4 w-4 text-accent" /> Verified official contacts</span>
      </div>
    </section>
  );
}
